import { Component, h } from "preact";
import { msg } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";
import { CloseIcon, PhoneIcon } from "../../utils/icons";

export class ContactsPage extends Component {
    render() {
        return <div>
            <div class="user-menu-header main-text-color p-2 text-base font-bold m-3 capitalize"><Trans>Contact us</Trans></div>
            <div class="main-text-color p-2 text-base w-full flex flex-col gap-4 items-center">

                <div class="bg-white rounded-lg shadow-md p-8 mb-8 max-w-4xl">

                    <h2 class="text-2xl font-semibold mb-4 text-gray-800">እንዴት ሊያገኙን ይችላሉ?</h2>

                    <div class="space-y-6">
                        <div class="flex items-start">
                            <div class="shrink-0">
                                <span class="inline-flex items-center justify-center h-8 w-8 rounded-full bg-blue-500 text-white font-bold">1</span>
                            </div>
                            <div class="ml-4">
                                <h3 class="text-lg font-medium text-gray-900">በቴሌግራም ቦት</h3>
                                <p class="mt-1 text-gray-600">
                                    ቴሌግራም ቦታችንን ይህን ሊንክ በመጫን <a href="https://t.me/jamibetbot" class="text-blue-600 hover:underline">https://t.me/jamibetbot</a> ወይም ይህን @jamibetbot በመፃፍ ሰርች ቢያረጉ ያገኙናል፣ በዚህ የቴሌግራም ቦት ያጋጠመዎትን ችግር ሲነግሩን መፍትሄ እንሰጣለን።
                                </p>
                            </div>
                        </div>
                    </div>

                    <p class="mt-8 text-center text-gray-700 font-semibold">እናመሰግናለን</p>

                </div>

                <div class="bg-white rounded-lg shadow-md p-8 w-full max-w-4xl">

                    <h1 class="text-3xl font-bold mb-4 text-gray-800 text-center">Welcome to our Contact Center</h1>

                    <p class="text-gray-600 mb-8 text-center max-w-2xl mx-auto">
                        We're here to help you with any questions or issues you might have. Please use our official Telegram bot to reach our support team. For your security, never share your password with anyone.
                    </p>

                    <div class="max-w-md mx-auto">
                        <div class="bg-gray-50 p-6 rounded-lg border border-gray-200 shadow-sm">
                            <h2 class="text-xl font-semibold mb-3 text-gray-900 text-center">💬 Telegram Bot</h2>
                            <p class="text-gray-700 mb-6 text-center text-sm">Our Telegram bot is an easy-to-use tool that answers your questions and provides direct support from our agents.</p>
                            
                            <div class="bg-white p-4 rounded-md border text-center">
                                <p class="font-medium text-gray-800 mb-3">How to Find Us:</p>
                                <div class="flex flex-col gap-3 text-gray-600 text-sm">
                                    <div class="bg-gray-50 p-2 rounded">
                                        <span class="font-semibold block mb-1">Username:</span> 
                                        <span class="text-blue-600 font-medium">@jamibetbot</span>
                                    </div>
                                    <div class="bg-gray-50 p-2 rounded">
                                        <span class="font-semibold block mb-1">Link:</span> 
                                        <a href="https://t.me/jamibetbot" target="_blank" rel="noopener noreferrer" class="text-blue-600 hover:underline font-medium">https://t.me/jamibetbot</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="mt-8 bg-red-100 border-l-4 border-red-500 text-red-700 p-4 max-w-2xl mx-auto" role="alert">
                        <p class="font-bold">Important Note:</p>
                        <p>Currently, our Telegram bot is the <strong>only supported method of communication</strong>. We do not offer support via Phone calls or Email. Please use the Telegram bot for the fastest and most secure assistance.</p>
                    </div>

                    <p class="mt-8 text-center text-gray-700">Thank you for your cooperation and understanding.</p>

                </div>

            </div>
        </div>
    }
}